import { render, staticRenderFns } from "./CustomerCrud.vue?vue&type=template&id=347503c2&"
import script from "./CustomerCrud.vue?vue&type=script&lang=js&"
export * from "./CustomerCrud.vue?vue&type=script&lang=js&"
import style0 from "./CustomerCrud.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports